function prefix<T extends { [key: string]: string | number }>(name: string, enums: T): T {
  const obj: any = {};
  Object.keys(enums).forEach((key: string) => {
    obj[key] = `${name}/${enums[key]}`;
  });
  return obj;
}

export default prefix;
